export const parseError = (err) =>
  err?.response?.data?.message || err.message || "Error desconocido";

export const filterProducts = (products, { search, filterCategory }) => {
  return products
    .filter((p) =>
      filterCategory === "all" ? true : p.category === filterCategory
    )
    .filter((p) => {
      const q = (search || "").trim().toLowerCase();
      if (!q) return true;
      return (
        (p.name || "").toLowerCase().includes(q) ||
        (p.sku || "").toLowerCase().includes(q) ||
        (p.category || "").toLowerCase().includes(q) ||
        (p.brand || "").toLowerCase().includes(q)
      );
    })
    .sort((a, b) => {
      if ((a.category || "") < (b.category || "")) return -1;
      if ((a.category || "") > (b.category || "")) return 1;
      if ((a.name || "") < (b.name || "")) return -1;
      if ((a.name || "") > (b.name || "")) return 1;
      return 0;
    });
};

export const calculateStock = (product) => {
  // Calcular total de stock en todos los almacenes
  const warehouse = product.warehouses?.reduce(
    (sum, wh) => sum + (wh.stock || 0),
    0
  ) || 0;
  
  // Calcular total de stock en técnicos
  const technicians = product.technicians?.reduce(
    (sum, tech) => sum + (tech.stock || 0),
    0
  ) || 0;
  
  // NO incluir stock de residuos peligrosos en el total
  const hazardousStock = product.hazardousStock ?? 0;
  const total = warehouse + technicians; // Excluir hazardousStock del total
  const warehousePct = total ? Math.round((warehouse / total) * 100) : 0;

  return {
    total,
    warehouse, // Total de todos los almacenes combinados
    technicians,
    hazardousStock,
    warehousePct,
  };
};

export const extractCategories = (products) => {
  return [
    "all",
    ...Array.from(new Set(products.map((p) => p.category).filter(Boolean))),
  ];
};

/**
 * Pluraliza la unidad de medida según la cantidad
 */
export const pluralizeUnit = (unit, quantity) => {
  if (!unit) return "u";
  
  const unitMap = {
    "pieza": quantity === 1 ? "Pieza" : "Piezas",
    "caja": quantity === 1 ? "Caja" : "Cajas",
    "paquete": quantity === 1 ? "Paquete" : "Paquetes",
    "lt": "lt",
    "ml": "ml",
    "kg": "kg",
    "g": "g",
  };
  
  return unitMap[unit] || unit;
};